<template>
  <Teleport to="#dialog">
    <transition appear name="fade">
      <div class="dialog">
        <div
          :class="['dialog-box', `${style?.cusClass || ''}`]"
          :style="`
            width:${style?.width || '400px'};
            height:${style?.height || '400px'}; 
            grid-template-rows:${style?.dialogRows}; 
            min-height:${style?.minHeight || ''}`"
        >
          <div v-if="!hideClose" class="dialog-cancel" @click="close">
            <i class="bi bi-x-circle-fill"></i>
          </div>
          <slot name="title">
            <p v-if="title" class="dialog-title">{{ title }}</p>
          </slot>
          <slot name="body"></slot>
          <slot name="footer"></slot>
        </div>
      </div>
    </transition>
  </Teleport>
</template>
<script>
import { inject } from 'vue';
export default {
  name: 'cus-dialog-in-dialog',
  setup() {
    const title = inject('inner_title', '');
    const close = inject('inner_close');
    const hideClose = inject('inner_hideClose');
    const { style } = inject('inner_style');
    return { title, close, hideClose, style };
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  @include dialog-basic;
}
</style>
